import React from 'react';

const CoreThesis = () => {
  return (
    <section id="about" className="relative">
      {/* Header with title */}
      <div className="bg-cream-100 py-8 md:py-12 text-center px-6">
        <h2
          className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-navy-900 tracking-wide mb-4"
          data-aos="fade-down"
        >
          Meaning of &lsquo;Commodity&rsquo; (Core Thesis)
        </h2>
        <div className="gold-divider max-w-xl mx-auto" />
      </div>

      {/* Skyline window — transparent to show scroll background */}
      <div className="h-[200px] md:h-[300px] lg:h-[400px]" />

      {/* Dark content section */}
      <div className="dark-section py-10 md:py-14 px-6 md:px-12">
        <div className="max-w-3xl mx-auto" data-aos="fade-up">
          <p className="font-body text-lg md:text-xl lg:text-2xl text-cream-200 leading-relaxed mb-8">
            At{' '}
            <span className="font-bold text-gold-400">Marquee,</span> the
            word &lsquo;Commodity&rsquo; is not limited to physical goods.
            It is a philosophy:
          </p>

          <div className="space-y-4 md:space-y-6 mb-10">
            <div className="flex items-start gap-3">
              <span className="text-gold-400 text-xl mt-1">&#8226;</span>
              <p className="font-body text-base md:text-lg lg:text-xl text-cream-200 leading-relaxed">
                A{' '}
                <span className="font-bold text-white">project</span> is a
                commodity &mdash; measurable, structured, priced, and
                optimized.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-gold-400 text-xl mt-1">&#8226;</span>
              <p className="font-body text-base md:text-lg lg:text-xl text-cream-200 leading-relaxed">
                A{' '}
                <span className="font-bold text-white">transaction</span>{' '}
                is a commodity &mdash; engineered for certainty, clarity,
                and execution discipline.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-gold-400 text-xl mt-1">&#8226;</span>
              <p className="font-body text-base md:text-lg lg:text-xl text-cream-200 leading-relaxed">
                A{' '}
                <span className="font-bold text-white">mandate</span> is a
                commodity &mdash; packaged into repeatable modules,
                deliverables, and outcomes.
              </p>
            </div>
          </div>

          <div className="gold-divider mb-8" />

          <p className="font-body text-sm md:text-base text-cream-300/60 text-center italic leading-relaxed">
            Marquee operates strictly as an independent corporate advisory
            platform. All regulated securities activity is performed by duly
            licensed third-party professionals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CoreThesis;
